import { render, staticRenderFns } from "./ProfileUniqueSip.vue?vue&type=template&id=13798df2&"
import script from "./ProfileUniqueSip.vue?vue&type=script&lang=js&"
export * from "./ProfileUniqueSip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports